import { STEP_ACTIONS } from './constants';

/**
 * A program step is fully described by its `action` (API 2026-10-12):
 * one action per resource catalog type, plus the assessment one.
 *
 *   sendSurvey  -> an assessment (surveys list)
 *   sendArticle -> a resource of type 'article'
 *   sendAudio   -> a resource of type 'podcast'
 *   sendVideo   -> a resource of type 'video'
 *
 * The API types the action by the key's catalog type on save and on
 * read, and rejects a key whose type does not match the action, so the
 * picker only ever offers matching keys.
 */

// `type` values as served by GET /resources.
export const RESOURCE_TYPE_BY_ACTION = {
  [STEP_ACTIONS.sendArticle]: 'article',
  [STEP_ACTIONS.sendAudio]: 'podcast',
  [STEP_ACTIONS.sendVideo]: 'video',
};

export const isSurveyAction = action => action === STEP_ACTIONS.sendSurvey;

/** Catalogue entries a resource action may choose from. */
export const resourcesForAction = (action, resources = []) => {
  const type = RESOURCE_TYPE_BY_ACTION[action];
  if (!type) return [];
  return (Array.isArray(resources) ? resources : []).filter(r => r?.type === type);
};
